import Vue from "vue";
// Plugins
import "./plugins/vue-drift";
import "./plugins/bootstrap-vue";
import "./plugins/vue-progressbar";
import "./plugins/material-design-icons";
import "./plugins/vue2-slideout-panel";
//import "./plugins/dr-vue-charts";

//import "./plugins/vue-css-donut-chart";

import VuePageTransition from "vue-page-transition";
Vue.use(VuePageTransition);

import SocialSharing from "vue-social-sharing";
Vue.use(SocialSharing);

import VueSweetalert2 from "vue-sweetalert2";

const options = {
  confirmButtonColor: "#f26743",
  cancelButtonColor: "#222222"
};
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2, options);

import VueContentPlaceholders from "vue-content-placeholders";
Vue.use(VueContentPlaceholders);

import Money from "@/components/ui/Money";
Vue.component("Money", Money);

import App from "./App.vue";
import { router, http } from "./http";
import store from "./store";

//Import Default Layouts
import Private from "./layouts/Private.vue";
import Public from "./layouts/Public.vue";
Vue.component("private", Private);
Vue.component("public", Public);

//Global components
import ReferralModal from "@/components/actions/ReferralModal";
Vue.component("ReferralModal", ReferralModal);
import InvestModal from "@/components/actions/InvestModal";
Vue.component("InvestModal", InvestModal);

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {})



Vue.config.productionTip = false;

Vue.use(http);

Vue.http.defaults.headers.common[
  "Authorization"
] = `Bearer ${localStorage.getItem("authToken")}`;

let app;
if (navigator.cookieEnabled) {
  app = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
} else {
  document.write("Please enable cookies to continue");
}

export default app;
